import { StyleSheet } from 'aphrodite';
import { background, brandPrimary, charmGray, lightGray, shuffleGray, white } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	selectedTab: {
		color: brandPrimary,
		borderBottom: `1px solid ${white}`,
	},
	backgroundTab: {
		color: charmGray,
		backgroundColor: background,
	},
	tab: {
		border: `1px solid ${shuffleGray}`,
		borderRadius: '8px 8px 0px 0px',
		padding: '16px 24px 12px 24px',
		textTransform: 'uppercase',
		verticalAlign: 'top',
		':disabled': {
			backgroundColor: lightGray,
			color: charmGray,
		},
	},
	tabList: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		maxHeight: 46,
	},
	tabListBorder: {
		display: 'inline-block',
		borderBottom: `1px solid ${shuffleGray}`,
		height: 17,
		padding: '16px 0px 12px 0px',
	},
	tabListSpacer: {
		width: 4,
	},
	tabRoot: {
		marginTop: 36,
	},
});
